import React from 'react'
import BybCancelRefund from './BybCancelRefund/BybCancelRefund'
import PageSeo from '../Common/Seo/PageSeo'

const CancleDeliveryPage = () => {
  return (
    <div>
        <PageSeo
          title="Cancellation and Refund Policy | Brew Your Brand"
          description="Read the Brew Your Brand cancellation and refund policy for digital products, brand tools, and service-related purchases."
          canonical="/cancellation-refund"
          ogTitle="Cancellation and Refund Policy | Brew Your Brand"
        />
        <BybCancelRefund/>
    </div>
  )
}

export default CancleDeliveryPage
